import { render, staticRenderFns } from "./VerificationCodes.vue?vue&type=template&id=47705ff8"
import script from "./VerificationCodes.vue?vue&type=script&lang=js"
export * from "./VerificationCodes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports